module.exports = __webpack_public_path__ + "media/images/flags/64/Lesotho-70f6c29f844460a3208d0701f7562153.png";